import { useEffect, useState } from "react";
import { Menu, Search, ShoppingBag, UserRound, X } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import Logo from "./Logo";
import SearchOverlay from "./SearchOverlay";
import { useCart } from "../lib/cart";
import { useAuth } from "../lib/auth";

export default function Header() {
  const [menu, setMenu] = useState(false);
  const [search, setSearch] = useState(false);
  const location = useLocation();
  const { count } = useCart();
  const { user } = useAuth();
  useEffect(() => setMenu(false), [location.pathname]);
  useEffect(() => {
    document.body.classList.toggle("menu-open", menu || search);
    return () => document.body.classList.remove("menu-open");
  }, [menu, search]);
  const active = (prefix) =>
    location.pathname === prefix || location.pathname.startsWith(`${prefix}/`);
  return (
    <>
      <header className="header">
        <Logo />
        <nav className="desktop-nav" aria-label="Primary navigation">
          <Link className={active("/shop") ? "active" : ""} to="/shop">
            SHOP
          </Link>
          <Link className={active("/about") ? "active" : ""} to="/about">
            ABOUT
          </Link>
          <Link className={active("/contact") ? "active" : ""} to="/contact">
            CONTACT
          </Link>
        </nav>
        <div className="header-actions">
          <button aria-label="Search" onClick={() => setSearch(true)}>
            <Search size={19} strokeWidth={1.6} />
          </button>
          <Link className="bag-button" to="/cart" aria-label="Enquiry cart">
            <ShoppingBag size={20} strokeWidth={1.5} />
            <span>{count}</span>
          </Link>
          <Link
            className="account-button"
            to={
              user
                ? user.role === "technician"
                  ? "/technician"
                  : [
                        "admin",
                        "operations",
                        "finance",
                        "support",
                        "super_admin",
                      ].includes(user.role)
                    ? "/admin"
                    : "/portal"
                : "/login"
            }
            aria-label="Account"
          >
            <UserRound size={18} />
          </Link>
          <button aria-label="Open menu" onClick={() => setMenu(true)}>
            <Menu size={22} strokeWidth={1.5} />
          </button>
        </div>
      </header>
      {menu && (
        <div className="menu-panel">
          <div className="menu-panel-top">
            <Logo />
            <button aria-label="Close menu" onClick={() => setMenu(false)}>
              <X size={24} strokeWidth={1.5} />
            </button>
          </div>
          <nav>
            <Link to="/" onClick={() => setMenu(false)}>
              Home
            </Link>
            <Link to="/shop" onClick={() => setMenu(false)}>
              Shop
            </Link>
            <Link to="/cart" onClick={() => setMenu(false)}>
              Enquiry Cart
            </Link>
            <Link
              to={user ? "/portal" : "/login"}
              onClick={() => setMenu(false)}
            >
              {user ? "My Account" : "Sign In"}
            </Link>
            <Link to="/about" onClick={() => setMenu(false)}>
              About
            </Link>
            <Link to="/contact" onClick={() => setMenu(false)}>
              Contact
            </Link>
          </nav>
          <div className="menu-footer">
            Innovating comfort, delivering excellence.
          </div>
        </div>
      )}
      <SearchOverlay open={search} onClose={() => setSearch(false)} />
    </>
  );
}